import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { MarketoLinkedService } from 'app/model/linkedservice/marketo.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MarketoLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                clientId: '*',
                clientSecret: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class MarketoLinkedServiceAdapter extends LinkedServiceAdapter<MarketoLinkedService> {
    protected modelConstructor(): new () => MarketoLinkedService {
        return MarketoLinkedService;
    }

    protected model(): IModel {
        return MarketoLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: MarketoLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.MarketoLinkedService;
        properties.type = Metamodel.modelFor(MarketoLinkedService).name;

        properties.typeProperties = {
            endpoint: linkedService.endpoint,
            clientId: linkedService.clientId,
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: MarketoLinkedService): Promise<MarketoLinkedService> {
        const properties = linkedServiceResource.properties as Model.MarketoLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.MarketoLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.endpoint = typeProperties.endpoint;
        linkedService.clientId = typeProperties.clientId;
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
